export const DILogoUploadTypes = {
  LogoUploadDispatcher: Symbol('LogoUploadDispatcher'),
  LogoUploadDispatcherFactory: Symbol('LogoUploadDispatcherFactory'),
  LogoSocketProcessingAdapter: Symbol('LogoSocketProcessing'),
  LogoSocketProcessingAdapterFactory: Symbol('LogoSocketProcessingFactory'),
};
